module.exports = __webpack_public_path__ + "static/media/tpn-events-v2-final.3b651809.jpg";